import { computed, ref } from 'vue'

const UNLOCK_KEY = 'nodemos-site-unlock'
const SITE_PASSWORD = '12345678'

const siteLocked = typeof __SITE_LOCKED__ !== 'undefined' && __SITE_LOCKED__

export function useSiteLock() {
  const unlocked = ref(sessionStorage.getItem(UNLOCK_KEY) === '1')
  const error = ref('')

  const isBlocked = computed(() => siteLocked && !unlocked.value)

  function tryUnlock(password) {
    if (password === SITE_PASSWORD) {
      sessionStorage.setItem(UNLOCK_KEY, '1')
      unlocked.value = true
      error.value = ''
      return true
    }
    error.value = 'Incorrect password.'
    return false
  }

  return { isBlocked, tryUnlock, error, siteLocked }
}